import React from "react";
import { useTranslation } from "react-i18next";
import { MessageSquare, Image, Eye, BookOpen } from "lucide-react";

const features = [
    {
        key: "describe",
        titleKey: "stepsExecutionPanel.startByDescribingWhatYouWantToBuild",
        icon: MessageSquare,
        color: "blue",
    },
    {
        key: "images",
        titleKey: "stepsExecutionPanel.uploadImagesAsReference",
        subtitleKey: "stepsExecutionPanel.shareScreenshotsOrDesigns",
        icon: Image,
        color: "purple",
    },
    {
        key: "preview",
        titleKey: "stepsExecutionPanel.instantlyPreviewChanges",
        subtitleKey: "stepsExecutionPanel.seeYourCreationsComeToLife",
        icon: Eye,
        color: "green",
    },
    {
        key: "knowledge",
        titleKey: "stepsExecutionPanel.setCustomKnowledge",
        subtitleKey: "stepsExecutionPanel.tailorEachEditToYourNeeds",
        icon: BookOpen,
        color: "amber",
    },
];

const colorMap = {
    blue: "bg-blue-50 border-blue-100 text-blue-600",
    purple: "bg-purple-50 border-purple-100 text-purple-600",
    green: "bg-green-50 border-green-100 text-green-600",
    amber: "bg-amber-50 border-amber-100 text-amber-600",
};

const iconBgMap = {
    blue: "bg-blue-100",
    purple: "bg-purple-100",
    green: "bg-green-100",
    amber: "bg-amber-100",
};

function WorkflowEmptyState() {
    const { t } = useTranslation();

    return (
        <div className="h-full bg-white flex items-center justify-center">
            <div className="max-w-sm mx-auto px-6 text-center space-y-6">
                <div className="space-y-2">
                    <h3 className="text-lg font-semibold text-gray-800">
                        {t("stepsExecutionPanel.noStepsYet")}
                    </h3>
                    <p className="text-sm text-gray-500">
                        {t("stepsExecutionPanel.startByChattingWithAI")}
                    </p>
                </div>

                <div className="space-y-3 text-left">
                    {features.map((f) => {
                        const Icon = f.icon;
                        return (
                            <div
                                key={f.key}
                                className={`flex items-start gap-3 p-3 rounded-xl border ${colorMap[f.color]}`}
                            >
                                <div
                                    className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${iconBgMap[f.color]}`}
                                >
                                    <Icon className="h-4 w-4" />
                                </div>
                                <div className="min-w-0">
                                    <p className="text-sm font-medium text-gray-700">
                                        {t(f.titleKey)}
                                    </p>
                                    {f.subtitleKey && (
                                        <p className="text-xs text-gray-500 mt-0.5">
                                            {t(f.subtitleKey)}
                                        </p>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default React.memo(WorkflowEmptyState);
